var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs, _path13, _defs2, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTgLogoBlackRgb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 255 62"
    },
    viewBox: "0 0 255 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0,.st2{fill-rule:evenodd;clip-rule:evenodd}.st2{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M236.7 57.6c-.5-.7-.5-1.8-.5-3.7V14.3l-1.9-.8s-2.4 1.4-6.4 3c-3.9 1.5-6.7 1.9-6.7 1.9v2.1c1 .2 2.1.3 2.8.9.6.5.8 1.3.8 2.4v29.9c0 1.9 0 3.1-.5 3.7-.5.6-1.3.8-2.3 1v2.1h17v-2.1c-1 0-1.9-.2-2.3-.8",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M61.9 40.3c.3-6.9 2.7-10.2 5.1-10.2 2.7 0 4.1 3.4 4.2 10.2h-9.3zm15.9-8.5c-2.5-2.6-6.3-3.9-10.7-3.9-9.6 0-16.1 6.9-16.1 17 0 9.8 6.4 17 16.1 17 6.8 0 11.2-2.8 14.4-8.7L79.9 52s-2.5 2.6-7.6 2.6c-5.6 0-9.9-4.4-10.4-11.6h19.7c.2-4.7-1.3-8.6-3.8-11.2z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M135.7 40.3c.3-6.9 2.7-10.2 5.1-10.2 2.7 0 4.1 3.4 4.2 10.2h-9.3zm15.9-8.5c-2.5-2.6-6.3-3.9-10.7-3.9-9.6 0-16.1 6.9-16.1 17 0 9.8 6.4 17 16.1 17 6.8 0 11.2-2.8 14.4-8.7l-1.6-1.2s-2.5 2.6-7.6 2.6c-5.6 0-9.9-4.4-10.4-11.6h19.7c.2-4.7-1.3-8.6-3.8-11.2z",
    className: "st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M201 55.6c-2.1 0-4-1.5-4-5.2 0-3.5 2-6.7 8.6-7v6.8c0 3.8-2.2 5.4-4.6 5.4m16.4 2c-.5-.7-.5-1.8-.5-3.7V40c0-6.6-3.5-12-14.1-12-4.1 0-6.9.5-9.2 1.7-2.3 1.2-3.6 3.3-3.6 5.3 0 2.4 1.5 4.4 4.3 4.4 2.6 0 4.2-1.5 4.7-4.2.3-1.4.4-2.2.9-3.1.5-.9 1.3-1.3 2.3-1.3 2 0 3.5 2.1 3.5 5.8V41c-2.3 0-6.9 0-10.9 1.2-5.6 1.6-8.1 5.2-8.1 10.1 0 5.4 3.8 9.3 9.7 9.3 5.3 0 8.6-2.7 10.2-5.8.8 3 3.7 5.3 8.6 5.3 3 0 4.6-.3 4.6-.3v-2.1c-.1-.1-1.8-.3-2.4-1.1",
    className: "st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M120.6 57.5c-.4-.5-.6-1.4-.7-2.7V39.5c0-3.4-.5-6.4-2.3-8.5-2.1-2.4-4.7-3-7.8-3-5.4 0-9.9 3-12 6.7v-5.8L96 28s-2.3 1.2-5.8 2.4c-3.7 1.2-6.4 1.7-6.4 1.7v2.1c1 .2 2.1.3 2.8.9.7.6.8 1.7.8 3.3v16.2c0 1.4-.2 2.2-.7 2.7-.7.8-2 1-2.9 1.1v2.1h18.6v-2.1c-1-.2-2.3-.3-2.9-1.1-.4-.5-.6-1.4-.7-2.7V40.1c0-2.1.5-3.5 1.4-4.6.9-1.2 2.5-2 4.1-2 1.5 0 2.5.5 3.3 1.5.7.9 1 2.3 1 3.9v15.8c0 1.4-.2 2.2-.7 2.7-.7.8-2 1-2.9 1.1v2.1h18.6v-2.1c-1-.1-2.3-.2-3-1",
    className: "st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M181 27.9c-4.4 0-7.7 3-9.1 6.9v-6.1L170 28s-2.3 1.2-5.8 2.4c-3.7 1.2-6.4 1.7-6.4 1.7v2.1c1 .2 2.1.3 2.8.9.6.5.8 1.3.8 2.4v17.1c0 1.4-.2 2.3-.7 2.8-.7.8-2 1-2.9 1.1v2.1h18.6v-2.1c-1-.2-2.3-.3-2.9-1.1-.4-.5-.6-1.3-.7-2.7V40.1c0-1.5.2-3 .6-4.1.6-1.6 1.8-2.4 2.8-2.4 3 0 2.9 5.6 6.9 5.6 3 0 4.2-2.6 4.1-5.3.1-2.9-1.9-6-6.2-6",
    className: "st0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "m117.5 5.5 2.3 4.6c0 .1.1.1.2.1l5.1.7c.2 0 .3.3.1.4l-3.7 3.6c-.1.1-.1.1-.1.2l.9 5.1c0 .2-.2.3-.3.3l-4.5-2.4h-.2l-4.5 2.4c-.2.1-.4-.1-.3-.3l.9-5.1c0-.1 0-.2-.1-.2l-3.7-3.6c-.1-.1-.1-.4.1-.4l5.1-.7c.1 0 .1-.1.2-.1l2.3-4.6c-.1-.2.1-.2.2 0",
    className: "st0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "m139.8 5.5 2.3 4.6c0 .1.1.1.2.1l5.1.7c.2 0 .3.3.1.4l-3.7 3.6c-.1.1-.1.1-.1.2l.9 5.1c0 .2-.2.3-.3.3l-4.5-2.4h-.2l-4.5 2.4c-.2.1-.4-.1-.3-.3l.9-5.1c0-.1 0-.2-.1-.2l-3.7-3.6c-.1-.1-.1-.4.1-.4l5.1-.7c.1 0 .1-.1.2-.1l2.3-4.6c-.2-.2.1-.2.2 0",
    className: "st0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "m162 5.5 2.3 4.6c0 .1.1.1.2.1l5.1.7c.2 0 .3.3.1.4l-3.7 3.6c-.1.1-.1.1-.1.2l.9 5.1c0 .2-.2.3-.3.3l-4.5-2.4h-.2l-4.5 2.4c-.2.1-.4-.1-.3-.3l.9-5.1c0-.1 0-.2-.1-.2l-3.7-3.6c-.1-.1-.1-.4.1-.4l5.1-.7c.1 0 .1-.1.2-.1l2.3-4.6c-.1-.2.1-.2.2 0",
    className: "st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "m184.3 5.5 2.3 4.6c0 .1.1.1.2.1l5.1.7c.2 0 .3.3.1.4l-3.7 3.6c-.1.1-.1.1-.1.2l.9 5.1c0 .2-.2.3-.3.3l-4.5-2.4h-.2l-4.5 2.4c-.2.1-.4-.1-.3-.3l.9-5.1c0-.1 0-.2-.1-.2l-3.7-3.6c-.1-.1-.1-.4.1-.4l5.1-.7c.1 0 .1-.1.2-.1l2.3-4.6c-.2-.2.1-.2.2 0",
    className: "st0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "m206.5 5.5 2.3 4.6c0 .1.1.1.2.1l5.1.7c.2 0 .3.3.1.4l-3.7 3.6c-.1.1-.1.1-.1.2l.9 5.1c0 .2-.2.3-.3.3l-4.5-2.4h-.2l-4.5 2.4c-.2.1-.4-.1-.3-.3l.9-5.1c0-.1 0-.2-.1-.2l-3.7-3.6c-.1-.1-.1-.4.1-.4l5.1-.7c.1 0 .1-.1.2-.1l2.3-4.6c-.1-.2.1-.2.2 0",
    className: "st0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M94.5 7.8c1.1 0 1.9.9 1.9 3.9h-4.2c.2-3.1 1.4-3.9 2.3-3.9m5.2.1C98.6 6.7 96.9 6 94.6 6c-4.2 0-7.4 3.2-7.4 7.6 0 4.3 3 7.5 7.4 7.5 3 0 5.1-1.1 6.5-3.7l-1.1-.9s-1.1 1.2-3.1 1.2c-2.3 0-4.1-1.5-4.4-4.2h9.1c0-2.8-.8-4.4-1.9-5.6",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(51.915)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    width: 34,
    height: 20.6,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2_00000028318562934901136960000009613636762057153704_",
    width: 34,
    height: 20.6,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path-1_00000142859882963567705920000010666108532778633866_",
    d: "M0 0h34v20.6H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M32.7 18.6c-.2-.3-.3-.7-.3-1.6v-5.8c0-1.5-.4-2.9-1.2-3.8-.8-.9-2-1.4-3.6-1.4-2 0-3.6 1-4.6 1.9V.6l-.9-.6s-1.6 1-5.5 1H.1L0 8.6h1.6s.8-6 5.1-6.1v14.8c0 .7-.2 1-.5 1.3-.4.3-1 .4-1.3.4v1.5H13.6V19c-.3 0-.9-.1-1.3-.4-.4-.3-.5-.8-.5-1.7V2.4c2.2 0 3.7 0 4.8.7 1.2.8 1.4 2.1 1.4 3.6V17c0 .9-.1 1.3-.3 1.6-.3.3-.9.4-1.3.5v1.5H24.6v-1.5c-.4-.1-1-.1-1.3-.5-.2-.3-.3-.8-.3-1.6v-5.5c0-.9.2-1.5.6-2 .4-.5 1.1-.9 1.8-.9s1.1.2 1.4.7c.3.4.4 1 .4 1.7v6c0 .9-.1 1.3-.3 1.6-.3.3-.9.4-1.3.5v1.5H34v-1.5c-.4-.1-1-.2-1.3-.5",
    style: {
      mask: "url(#mask-2_00000028318562934901136960000009613636762057153704_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0 10.185)"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000031892306700462016340000015881128726380096145_",
    width: 46.5,
    height: 51.8,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4_00000140713471874708292800000013329198804646030748_",
    width: 46.5,
    height: 51.8,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000031892306700462016340000015881128726380096145_)"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path-3_00000161627198384560575130000001018250320217264271_",
    d: "M0 0h46.5v51.8H0z",
    className: "st2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    d: "M46.5 30.7v-6.5l-1.9-1.4s-3.5 1.3-8.5 2.3c-5 .9-10.1 1.2-10.1 1.2V29s3.4.4 6 1.3c2.7.9 3.9 2.4 3.9 4.6v9.2c-1.5.4-3.4.7-5.4.7-9.1 0-17-7.4-17-21.3 0-12.9 6.5-19 12.3-19 3.7 0 6.5 2.1 9.8 5.6 3.4 3.6 6.3 8.5 6.3 8.5h2.7S44.5 8 44.5 4.1c0 0-7.3-3.9-18-3.9C19.3 0 12.9 2.3 8.2 6.5c-5 4.4-8.2 11.2-8.2 19 0 7.8 2.7 14.4 7.5 19.1 4.6 4.6 10.8 7.2 18.2 7.2 5.7 0 9.3-1 14-3.3 4.6-2.3 6.8-5.1 6.9-5.2l-.1-12.6z",
    style: {
      mask: "url(#mask-4_00000140713471874708292800000013329198804646030748_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-32",
    d: "M248.2 55.8c.5 0 .8-.2.8-.6 0-.4-.3-.6-.8-.6h-1v1.3h1zm-2.4-2.6h2.5c.8 0 1.4.2 1.8.6.3.3.5.7.5 1.2 0 .8-.4 1.3-1.1 1.6l1.3 1.8H249l-1.1-1.6h-.6v1.6h-1.5v-5.2zm6.6 2.8c0-2.5-1.9-4.5-4.4-4.5-2.5 0-4.4 2-4.4 4.5 0 2.4 1.9 4.4 4.4 4.4 2.5.1 4.4-2 4.4-4.4zm-9.4 0c0-2.7 2.2-5 5-5s5 2.3 5 5-2.2 5-5 5-5-2.3-5-5z",
    className: "st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogoBlackRgb);
export default __webpack_public_path__ + "static/media/TGLogo-Black-RGB.c627e510a2801d51dd67ee4263230615.svg";
export { ForwardRef as ReactComponent };